import { ArchiveIcon } from "@radix-ui/react-icons";
import { useSelector } from "react-redux";
import Loading from "src/components/Loading";
import SessionCard from "src/components/SessionCard";
import { Button } from "src/components/ui/button";
import { Card, CardContent } from "src/components/ui/card";
import { PermilleChartData } from "src/lib/hooks/usePermilleChartData";
import { DrunkDrink, Event, Photo } from "src/lib/slices/alcoholSlice";
import useSWR from "swr";

const fetcher = (token) => async (url) => {
  const res = await fetch(url, { headers: { Authorization: token } });

  return res.json();
};

export default function Sessions() {
  const user = useSelector((state: any) => state.user);

  const { data, error, isLoading } = useSWR<Session[]>(
    `${process.env.REACT_APP_API_URL}/sessions`,
    fetcher(user.token)
  );

  return (
    <>
      <h2 className="text-lg font-bold px-4">Seance</h2>

      {isLoading && <Loading className="pt-4" />}
      {error && !isLoading && (
        <div style={{ textAlign: "center" }}>Vyskytla se chyba</div>
      )}

      {data && data.length === 0 && (
        <>
          <div className="pt-4 text-muted-foreground text-center">
            Nemáš žádné seance.
          </div>
          <Card className="pt-4 text-muted-foreground text-center w-fit mx-auto mt-4">
            <CardContent>
              <div>Novou seanci si uložíš tlačítkem</div>
              <Button size="icon" disabled>
                <ArchiveIcon />
              </Button>
              <div>na stránce kalkulačky.</div>
            </CardContent>
          </Card>
        </>
      )}

      {!!data?.length && (
        <div className="p-4 flex flex-col gap-4">
          {data?.map((session) => (
            <SessionCard session={session} key={session._id} />
          ))}
        </div>
      )}
    </>
  );
}

export type Session = {
  _id: string;
  userId: string;
  name: string;
  public: boolean;
  alcoholData: {
    DrunkDrinks: DrunkDrink[];
    route: { latitude: number; longitude: number; timestamp: number }[];
    photos: Photo[];
    events: Event[];
  };
  permilleChartData?: PermilleChartData;
  sessionMaxPermille: number;
};
